module.exports = __webpack_public_path__ + "static/img/btn_commic001.cd88c48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_commic001.svg
// module id = 52
// module chunks = 0